import './StandoutAthleteCard.css';

export default function StandoutAthleteCard({ image, name, sport, sportType, award, week, level, onBadgeClick, onOrgClick, showWeekLabel }) {
  return (
    <div className="sac-card" onClick={onBadgeClick}>

      {/* ── Image ── */}
      <div className="sac-image-wrap">
        <img src={image} alt={name} className="sac-image" />
        {showWeekLabel && week && <div className="sac-week-label">{week} Standout</div>}
        {award && (
          <div className="sac-award-badge">
            <span className="sac-award-text">{award.toUpperCase()}</span>
          </div>
        )}
      </div>


      {/* ── Info ── */}
      <div className="sac-body">
        <h3 className="sac-name">{name}</h3>
        <p className="sac-sub">
          <span
            className={onOrgClick ? 'sac-org-btn' : ''}
            onClick={onOrgClick ? (e) => { e.stopPropagation(); onOrgClick(); } : undefined}
          >
            {sport}
          </span>
          {sportType && (
            <>
              <span className="sac-sep"> • </span>
              <span>{sportType}</span>
            </>
          )}
          {level && (
            <>
              <span className="sac-sep"> • </span>
              <span className="sac-level">{level}</span>
            </>
          )}
        </p>
      </div>

      {/* ── View Performance ── */}
      <div className="sac-footer">
        <button
          className="sac-view-btn"
          onClick={(e) => { e.stopPropagation(); onBadgeClick && onBadgeClick(); }}
        >
          View Performance
        </button>
      </div>

    </div>
  );
}
